import { back as backIcon } from '@assets'
import { AdminDashboardFormWrapper, Loading, ModalError } from '@components'
import { useGetAdminDashboard, useGetFeatures } from '@hooks'
import { useNavigation } from '@hooks/navigation'

import { Style } from './style'
import { FEATURE } from '@constants'
import { hasFeature } from '@helpers/dashboard'

const AdminDashboardDetailContainer = ({ dashboardId }: { dashboardId: string }) => {
  const { isLoading, data: summaryDashboard, isSuccess } = useGetAdminDashboard(dashboardId)
  const { isLoading: isFeatureLoading, data: featureList} = useGetFeatures()
  const { goToAdminDashboardList} = useNavigation()


  if (isLoading || isFeatureLoading) {
    return <Loading />
  }

  const isAllowUpdateStatus = hasFeature(featureList, FEATURE.DASHBOARD_MANAGEMENT)

  if(summaryDashboard && !isAllowUpdateStatus) {
    delete summaryDashboard.is_active
  }

  const isNotFound = !isSuccess

  return (
    <Style>
      <div className='btn-back' onClick={() => goToAdminDashboardList()}>
        <img className='back' src={backIcon} alt={'back.svg'} />
        Back
      </div>
      {summaryDashboard && <div className='detail'><AdminDashboardFormWrapper summaryDashboard={summaryDashboard} isAllowUpdateStatus={isAllowUpdateStatus} /></div>}
      {isNotFound && (
        <ModalError isDisplay={isNotFound} content={` Can't find dashboard detail.`} closeModal={goToAdminDashboardList} />
      )}
    </Style>
  )
}

export default AdminDashboardDetailContainer
